// extracted by mini-css-extract-plugin
module.exports = {"productCarousel":"ci","itemsContainer":"di"};